import { ENV } from '../../environment';

type Config = {
  endpoint: string;
};

const DevEnv: Config = {
  endpoint: 'https://api.dev.concreit.com',
};

const StagingEnv: Config = {
  endpoint: 'https://api.staging.concreit.com',
};

const ProdEnv: Config = {
  endpoint: 'https://api.concreit.com',
};

export const config: Config = ENV === 'development' ? DevEnv : ENV === 'production' ? ProdEnv : StagingEnv;
